let drawCounter = 0;
/**
 * Render every diagram under `root`, in `theme` ('default' or 'dark').
 *
 * Safe to call again — on a theme change, or after the preview re-renders:
 * the source `<pre>` is kept (hidden by CSS once drawn), so each pass renders
 * from the original text. A diagram whose syntax is wrong gets an honest
 * panel — what is wrong, in mermaid's words — with the source still visible
 * below it, because "fix line 3" needs line 3 on the screen.
 */
export async function drawMermaidDiagrams(root, mermaid, theme) {
    const containers = root.querySelectorAll('.sls-mermaid');
    if (containers.length === 0)
        return;
    mermaid.initialize({ startOnLoad: false, theme, securityLevel: 'strict' });
    for (const container of containers) {
        const pre = container.querySelector('.sls-mermaid__src');
        const source = pre?.textContent ?? '';
        let target = container.querySelector('.sls-mermaid__drawing');
        if (!target) {
            target = container.ownerDocument.createElement('div');
            target.className = 'sls-mermaid__drawing';
            container.appendChild(target);
        }
        try {
            // Parse before render, and not as an optimisation: on bad input
            // `render` injects mermaid's own error graphic straight into the page
            // body, outside the container — a bomb drawing over the navigation.
            // `parse` throws cleanly and touches nothing.
            await mermaid.parse(source);
            const { svg } = await mermaid.render(`sls-mermaid-draw-${++drawCounter}`, source);
            target.innerHTML = svg;
            container.classList.remove('sls-mermaid--broken');
            container.classList.add('sls-mermaid--drawn');
        }
        catch (error) {
            target.innerHTML = mermaidErrorPanel(error instanceof Error ? error.message : String(error));
            container.classList.remove('sls-mermaid--drawn');
            container.classList.add('sls-mermaid--broken');
        }
    }
}
/** The invalid-syntax view: mermaid's own words, escaped, above the source. */
export function mermaidErrorPanel(message) {
    const safe = String(message ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    return `<div class="sls-mermaid__error"><strong>This diagram has a syntax error.</strong><pre>${safe}</pre></div>`;
}
//# sourceMappingURL=mermaid-client.js.map